import type { AppRouteModule } from '/@/router/types';
// import { storeToRefs } from 'pinia';

import { LAYOUT } from '/@/router/constant';

const dashboard: AppRouteModule = {
  path: '/backlog',
  name: 'Backlog',
  component: LAYOUT,
  redirect: '/backlog/managerChange',
  meta: {
    icon: 'fe:notice-active',
    title: '待办事项',
    orderNo: 80,
    // tag: {
    //   dot: false,
    //   // 内容
    //   content: '5',
    //   // 类型
    //   type: 'warn',
    // },
  },
  children: [
    {
      path: 'managerChange',
      name: 'BacklogManagerChange',
      component: () => import('/@/views/admin/backlog/ManagerChange.vue'),
      meta: {
        title: '更换客户经理申请',
        ignoreKeepAlive: false,
        auth: '',
        // badge: () => globalStore.number,
      },
    },
    {
      path: 'customerCreate',
      name: 'BacklogCustomerCreateList',
      component: () => import('/@/views/admin/backlog/CustomerCreateList.vue'),
      meta: {
        title: '企业客户创建列表',
        ignoreKeepAlive: false,
        auth: '',
        // badge: () => globalStore.number,
      },
    },
  ],
};

export default dashboard;
